import { Button } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledGoBackButton = styled(Button)<{ token: any }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  min-height: 32px;
  padding: 4px 12px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.4;
  text-align: center;
  background-color: ${({ token }) => token.colorPrimaryBgHover};

  .anticon {
    font-size: 18px;
    flex-shrink: 0;
  }
`;

export const StyledLink = styled(Link)`
  width: fit-content;
  text-decoration: none;
`;
